import {
  filterGender,
  filterNumbers,
  formatDate,
  formatDateBr,
  switchGender,
} from "./subscriptionFunctions";

export const mountParticipantToRequest = (
  form,
  isUpdatingData,
  participantAge,
  caravanistUuid
) => {
  const {
    cpf,
    rg,
    name,
    birthdate,
    email,
    mobile,
    gender,
    genderDetails,
    selfRefer,
    specialNeed,
    specialNeeds,
    terms,
    imageAssignment,
    marketing,
    nationality,
    maritalStatus,
    occupation,
    address,
    photo,
    responsible: responsibleData,
  } = { ...form };

  let responsible = null;
  if (participantAge < 18) {
    const adultFullName = responsibleData.name;

    const nameAdultsParts = adultFullName ? adultFullName.split(" ") : [];
    const firstAdultName = nameAdultsParts[0];
    const lastAdultName = adultFullName
      ? adultFullName.replace(firstAdultName, "")
      : "";

    responsible = {
      cpf: filterNumbers(responsibleData.cpf),
      id: responsibleData.id,
      rg: responsibleData.rg,
      name: firstAdultName,
      surname: lastAdultName,
      mobile: filterNumbers(responsibleData.mobile),
      email: responsibleData.email,
    };
  }

  const nameParts = name ? name.split(" ") : [];
  const firstName = nameParts[0];

  const lastName = name ? name.replace(firstName, "") : "";

  const participant = {
    photo,
    cpf: filterNumbers(cpf),
    rg: rg ? rg : null,
    name: firstName,
    surname: lastName,
    birthdate: formatDate(birthdate),
    mobile: filterNumbers(mobile),
    gender: filterGender(gender),
    genderDetails,
    selfRefer,
    specialNeed: specialNeeds === "1" ? specialNeed || null : null,
    status: true,
    email: email || undefined,
    terms,
    imageAssignment,
    marketing: marketing ? true : false,
    caravanist: { uuid: caravanistUuid },
    responsible,
    nationality,
    maritalStatus,
    occupation,
    zipCode: address.zipCode,
    state: address.state,
    city: address.city,
    neighborhood: address.neighborhood,
    street: address.street,
    number: address.number,
    complement: address.complement,
  };

  if (participantAge < 18) {
    participant.mobile = undefined;
  }

  if (isUpdatingData) {
    participant.status = undefined;
    participant.cpf = undefined;
    participant.caravanist = undefined;
  }

  return participant;
};

export const populateForm = (form, participantObj) => {
  const updatedParticipant = {
    ...participantObj,
    caravanist: undefined,
  };

  // fixing birthdate format
  updatedParticipant.birthdate = formatDateBr(updatedParticipant.birthdate);

  if (updatedParticipant.name && updatedParticipant.surname) {
    updatedParticipant.name =
      updatedParticipant.name?.trim() +
      " " +
      updatedParticipant.surname?.trim();
  }

  // fixing gender format
  updatedParticipant.gender = switchGender(updatedParticipant.gender);

  // fixing specialNeed format
  updatedParticipant.specialNeeds = "0";
  if (updatedParticipant.specialNeed) {
    updatedParticipant.specialNeeds = "1";
  }
  const { responsible = {} } = updatedParticipant;
  const { address = {} } = updatedParticipant;

  updatedParticipant.responsible = responsible || {};
  updatedParticipant.address = address || {};

  Object.keys(form).forEach((propName) => {
    form[propName] = updatedParticipant[propName];
  });

  console.log("populating.......", updatedParticipant);

  if (updatedParticipant?.responsible) {
    if (
      updatedParticipant.responsible?.name &&
      updatedParticipant.responsible?.surname
    ) {
      form.responsible.name =
        updatedParticipant.responsible?.name.trim() +
        " " +
        updatedParticipant.responsible.surname.trim();
    }
  }
};

const clearValidations = (thisErrors) => {
  thisErrors.clear();
  thisErrors.add({});
};

export const validateStep3 = (
  thisErrors,
  participantAge,
  validatedTabResults,
  thisValidator
) => {
  clearValidations(thisErrors);
  validatedTabResults[2] = false;

  let fieldsToCheck = subscriptionFieldsToCheck[2];
  fieldsToCheck = participantAge < 18 ? fieldsToCheck[1] : fieldsToCheck[0];

  let hasErrors = 0;
  fieldsToCheck.forEach(async (field) => {
    if (await thisValidator.validate(field)) {
      hasErrors++;
    }
  });

  if (!hasErrors && this.errors.items && this.errors.items.length < 2) {
    validatedTabResults[2] = true;
  }
};

export const subscripionFormFiels = {
  cpf: "",
  birthdate: "",
  name: "",
  surname: "",
  mobile: "",
  specialNeed: null,
  specialNeeds: "",
  terms: null,
  imageAssignment: null,
  gender: null,
  genderDetails: "",
  selfRefer: "",
  email: "",
  rg: "",
  responsible: {},
  address: {
    zipCode: "",
    state: "",
    city: "",
    neighborhood: "",
    street: "",
    number: "",
    complement: "",
  },
  nationality: "",
  maritalStatus: "",
  occupation: "",
  photo: "",
};
export const subscriptionFieldsToCheck = [
  [],
  ["cpf", "birthdate"],

  [
    "name",

    "terms",

    "rg",
    "mobile",
    "email",
    "nationality",

    "occupation",
    "zipCode",
    "state",
    "city",
    "neighborhood",
    "street",
    "number",
  ],
  [
    "name",

    "terms",
    "responsibleName",
    "responsibleRg",
    "responsibleCpf",
    "responsibleMobile",
    "responsibleEmail",
    "nationality",

    "occupation",
    "zipCode",
    "state",
    "city",
    "neighborhood",
    "street",
    "number",
  ],
  // step 2
];

export const subscriptionGenderList = [
  {
    id: null,
    name: "Selecione...",
    label: "Selecione..",
    code: 0,
    value: null,
    text: "Selectione...",
  },
  {
    id: 1,
    name: "Masculino",
    label: "Masculino",
    code: 1,
    value: 1,
    text: "Masculino",
  },
  {
    id: 2,
    name: "Feminino",
    label: "Feminino",
    code: 2,
    value: 2,
    text: "Feminino",
  },
  {
    id: 3,
    name: "Outro",
    label: "Outro",
    code: 3,
    value: 3,
    text: "Feminino",
  },
];

export const subscriptionMaritalStatusList = [
  {
    id: "",
    name: "Selecione...",
  },
  {
    id: "Casado",
    name: "Casado",
  },
  {
    id: "Solteiro",
    name: "Solteiro",
  },
  {
    id: "Viúvo",
    name: "Viúvo",
  },
  {
    id: "Divorciado",
    name: "Divorciado",
  },
  {
    id: "Separado judicialmente",
    name: "Separado judicialmente",
  },
];

export const validateMissingFields = () => {
  const requiredFields = ["gender"];
};

export const sanitizeParticipantFormToPost = (participant) => {
  if (!participant) return;
  if (participant.name) {
    const name = participant.name;
    participant.name = name.trim();
  }
  if (participant.surname) {
    const surname = participant.surname;
    participant.surname = surname.trim();
  }

  if (participant?.responsible && participant?.responsible?.name) {
    const responsibleName = participant.responsible.name;
    participant.responsible.name = responsibleName.trim();
  }
  if (participant?.responsible && participant?.responsible?.surname) {
    const responsibleSurname = participant.responsible.surname;
    participant.responsible.surname = responsibleSurname.trim();
  }
};
